import React from "react";
import styled from "styled-components";

const ErrorPage = () => {
  return (
    <Error>
      <div>
        <h1>Login to do this action </h1>
      </div>
    </Error>
  );
};

export default ErrorPage;

const Error = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60vh;
  & > div {
    opacity: 0.79;
    box-shadow: 0px 0px 30px 0px yellow;
    border-radius: 20px;
    width: 40%;
    height: 250px;
    background-color: #ffff00;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
  }
`;
